import { IonCol, IonContent, IonGrid, IonPage, IonRow, useIonViewDidEnter } from "@ionic/react";
import { useState } from "react";
import { useLocation } from "react-router";
import CreditPay from "../../components/CreditPay";
import Footer from "../../components/Footer";
import { User } from "../../models/data";

interface CreditProps {
    user: User
}
const DonateOnline: React.FC<CreditProps> = (props) => {
    const location: any = useLocation();
    useIonViewDidEnter(() => {
        setData(location.state.data)
    });

    const [data, setData] = useState<any>();

    return (
        <IonPage className="viewContainer">
            <IonContent>
                <IonGrid>
                    <IonRow>
                        <IonCol>

                            {data && <CreditPay type='donate' donateData={data} amount={data.amount} user={props.user}></CreditPay>}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            <Footer></Footer>
            </IonContent>
        </IonPage>
    );

}

export default DonateOnline;